import React from 'react';
import './ServicePage.css';

const TrafficInsurance = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>🚗 Trafik Sigortası</h1>
          <p>Zorunlu trafik sigortası ile araçlarınızı güvence altına alın</p>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <section className="service-section">
            <h2>Trafik Sigortası Nedir?</h2>
            <p>
              Trafik sigortası, motorlu araçlar için zorunlu bir sigorta türüdür. 
              Araç sahiplerinin üçüncü şahıslara verebileceği zararları karşılamak 
              amacıyla yapılan bu sigorta, yasal bir zorunluluktur.
            </p>
          </section>

          <section className="service-section">
            <h2>Kapsamı</h2>
            <ul className="service-list">
              <li>Üçüncü şahıs can ve mal güvenliği</li>
              <li>Maddi zararların karşılanması</li>
              <li>Yasal yükümlülüklerin yerine getirilmesi</li>
            </ul>
          </section>

          <section className="service-section">
            <h2>Avantajları</h2>
            <ul className="service-list">
              <li>Yasal zorunluluğu karşılar</li>
              <li>Üçüncü şahıslara karşı koruma sağlar</li>
              <li>Uygun fiyatlı sigorta çözümü</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TrafficInsurance;

